package com.castly.admin.ui.preview

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

/**
 * Heart icon overlay for like indicators on carousel items and content cards.
 * Shows filled red heart if liked, outline heart if not.
 *
 * @param isLiked Whether the content is currently liked
 * @param onClick Optional callback for like/unlike action. If null, indicator is display-only.
 * @param size Size of the heart icon in px (default: 20)
 */
@Composable
fun PreviewLikeIndicator(
    isLiked: Boolean,
    onClick: (() -> Unit)? = null,
    size: Int = 20
) {
    val heartChar = if (isLiked) "\u2764\uFE0F" else "\u2661" // ❤️ or ♡

    if (onClick != null) {
        Button({
            onClick { e ->
                e.stopPropagation()
                onClick()
            }
            style {
                backgroundColor(Color.transparent)
                border(0.px)
                cursor("pointer")
                fontSize(size.px)
                padding(2.px)
                lineHeight("1")
                property("filter", if (!isLiked) "drop-shadow(0 1px 2px rgba(0,0,0,0.3))" else "none")
            }
        }) {
            Text(heartChar)
        }
    } else {
        Span({
            style {
                fontSize(size.px)
                lineHeight("1")
                property("filter", if (!isLiked) "drop-shadow(0 1px 2px rgba(0,0,0,0.3))" else "none")
            }
        }) {
            Text(heartChar)
        }
    }
}
